import React from "react";
import "./tabs.css";
import msg_line from "../../assets/images/msg_line.png";
/**
 *
 * @param  {TabProps} from the api
 * @return {Tabs} global component
 */
export default function Tabs({ selectedTab, onClick, labels }: any) {
  // console.log(labels)
  return (
    <div className="d-flex-row col-12">
      {labels.length > 0 && labels.map((label: any, index:number) =>  (
        
        <div className="col-5 d-flex flex-column align-items-center" key={index}>
      <div className=" inactive_clr mb-2" >
        {/* <img src={labels.inActiveImg} alt="..." className="" width="15px" height="15px" /> */}
        {selectedTab === label.tab ? label.activeImg : label.inActiveImg}
        <span className={`fw-bold f-14 px-2  cursor ${selectedTab === label.tab && 'blue_clr'}`}>{label.name}</span>
        
      </div>
      {selectedTab === label.tab && <img src={msg_line} alt="" />}
      </div>
      )
      )}
    </div>
  );
}
